export enum USER_ROLE {
  ROLE_SUPERVISOR = 'ROLE_SUPERVISOR',
  ROLE_PARTNER_ADMIN = 'ROLE_PARTNER_ADMIN',
  ROLE_PARTNER_USER = 'ROLE_PARTNER_USER',
}

export interface User {
  id: string;
  email: string;
  full_name: string;
  roles: USER_ROLE[];
  organization_id: string;
}
